import { ShoppingCartService } from './../inventory/shopping-cart.service';
import { Http, Headers, URLSearchParams, RequestOptions } from "@angular/http";
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/share';

import { CacheService } from '../core/cache.service';
import { ApiService } from '../core/api.service';
import { Mappings } from '../../shared/mapping';
import { HttpParam } from "./../../models/core/http-param";
import { Register } from "./../../models/cms/register";
import { LanguageService } from './language.service';

@Injectable()
export class RegisterService {
        constructor
                (
                public _api: ApiService,
                public _cache: CacheService,
                private mappings: Mappings,
                private cartService: ShoppingCartService,
                private languageService: LanguageService
                ) { }

        private facebookLoginData: any;

        sendInfoRequest(parameters: Register) {
                let cartId = this.cartService.getCartId();
                parameters.CartId = cartId;
                
                parameters.EmailRegister = parameters.EmailRegister ? parameters.EmailRegister.toLowerCase() : "";
                parameters.EmailRepeat = parameters.EmailRepeat ? parameters.EmailRepeat.toLowerCase() : "";
                parameters.PecEmail = parameters.PecEmail ? parameters.PecEmail.toLowerCase() : "";
                 
                return this._api.post(this.mappings.Web_Api_Post_Register, parameters)
                        .do(result => result)
                        .share();
        }

        getRegisterPageData(lang: string) {
                let url = this.mappings.Web_Api_Get_Register_Data.replace('{lang}', lang);

                return this._api.get(url);
        }

        confirmationRegistration(id: string) {
                let url = this.mappings.Web_Api_Post_Confirm_Registration.replace('{id}', id);

                return this._api.post(url);
        }

        setFacebookLoginData(registerData: any) {
                this.facebookLoginData = registerData;
        }

        getFacebookLoginData() {
                return this.facebookLoginData;
        }

        getRegistrationCompletePageData()
        {
                let lang = this.languageService.getLongLang();
                let url = this.mappings.Web_Api_Get_Registration_Complete_Page_Data.replace('{lang}', lang);

                return this._api.get(url);                
        }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/cms/register.service.ts